import { useState, useMemo, useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Lottie from 'react-lottie';
import qs from 'query-string';
import styles from './index.module.sass';
import Video from 'components/video';
import refuelingTutorial01 from 'lottie/tutorial_refueling_01.json';
import refuelingTutorial02 from 'lottie/tutorial_refueling_02-linebank.json';
import refuelingTutorial03 from 'lottie/tutorial_refueling_03.json';
import parkingTutorial01 from 'lottie/tutorial_parking_01.json';
import parkingTutorial02 from 'lottie/tutorial_parking_02.json';
import parkingTutorial03 from 'lottie/tutorial_parking_03.json';
import iconNavigate from 'assets/icon_tutorial_03.svg';
import iconPlay from 'assets/icon_play.svg';
import iconArrow from 'assets/icon_cad_arrow.svg';
import { PATH } from 'config';
import amplitude from 'service/amplitude';
import UseIntersect from 'helpers/use-intersect';
import { useAppContext } from 'use-app';

const ServiceInstruction = () => {
  const [videoShow, setVideoShow] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const parseSearch = qs.parse(location.search);
  const service = parseSearch.service || 'refueling';
  const stepList = useMemo(() => [], []);
  const [lottieState, setLottieState] = useState([true, true, true]);
  const { setElement } = UseIntersect(entry => {
    let idNum = entry.target.id.split('-')[1];
    setLottieState(prev => {
      return prev.map((x, key) => (idNum - 1 >= key ? false : true));
    });
  }, 1.0);
  const { state: appState } = useAppContext();
  const { isUsingLegacyReceiptWording } = appState.bootstraps;

  useEffect(() => {
    setElement(stepList.map(item => item.element));
  }, [stepList]);

  const initialData = {
    refueling: {
      about: '加油',
      name: '加油站',
      videoId: 'JtX0acvon5A',
      steps: [
        {
          lottie: refuelingTutorial01,
          title: '前往加油站',
          content: '前往麻吉付支援加油站，加油前與站員說「我要使用麻吉付」與統編。',
        },
        {
          lottie: refuelingTutorial02,
          title: '點擊同意付款',
          content: '等待加油結束，LINE 收到請求同意推播通知，點擊「授權加油付款」完成。',
        },
        {
          lottie: refuelingTutorial03,
          title: '索取發票',
          content: isUsingLegacyReceiptWording
            ? '記得索取發票即可離開，將會收到 Email 消費明細。'
            : '加油完成，部分加油站發票自動存入設定載具，現場免拿發票。',
        },
      ],
    },
    parking: {
      about: '停車',
      name: '停車場',
      videoId: 'j-_wTEnxNuQ',
      steps: [
        {
          lottie: parkingTutorial01,
          title: '前往停車場',
          content: '前往麻吉付支援停車場，車牌辨識直接進場，免取票卡。',
        },
        {
          lottie: parkingTutorial02,
          title: '即時追蹤停車時數',
          content: '停車中，可在服務主頁即時追蹤停車時數與金額狀態。',
        },
        {
          lottie: parkingTutorial03,
          title: '離場自動扣款',
          content: '車牌辨識直接離場，免至繳費機，出場自動完成扣款。',
        },
      ],
    },
  };

  const currentInstructionData = initialData[service];

  useEffect(() => {
    amplitude.serviceInstruction_pageview(currentInstructionData.about);
  }, []);

  const stepItemRef = useCallback(
    node => {
      if (node !== null) {
        stepList.push({
          element: node,
          lottieRun: false,
        });
      }
    },
    [stepList]
  );

  return (
    <div className={styles['service-instruction']}>
      <Video videoId={currentInstructionData.videoId} show={videoShow} onClose={() => setVideoShow(false)} />
      <h3>我要{currentInstructionData.about}</h3>
      <div className={styles.steps}>
        {currentInstructionData.steps.map((step, key) => {
          return (
            <div className={styles.step} id={`step-${key}`} ref={stepItemRef}>
              <h4>{step.title}</h4>
              <p>{step.content}</p>
              <Lottie
                isStopped={lottieState[key - 1]}
                options={{
                  loop: false,
                  animationData: step.lottie,
                }}
              />
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.button} ${styles.video}`}
        onClick={() => {
          amplitude.serviceInstruction_playVideo_onClick(currentInstructionData.about);
          setVideoShow(true);
        }}
      >
        <img src={iconPlay} alt="play" />
        {currentInstructionData.about}付款使用影片
      </div>
      <div
        className={`${styles.button} ${styles.navigate}`}
        onClick={() => {
          let { about, name } = currentInstructionData;
          amplitude.serviceInstruction_support_onClick(about, name);
          history.push({ pathname: PATH.MAPS, search: `?type=${service}` });
        }}
      >
        <div>
          <img src={iconNavigate} alt="navigate" />
          導航至支援{currentInstructionData.name}
        </div>
        <img src={iconArrow} alt="arrow" className={styles.arrow} />
      </div>
    </div>
  );
};

export default ServiceInstruction;
